export default function setField({main, on, elm, state}) {
	const selectChoices = elm.querySelector('select-choices');
	const currentFilters = [];

	main(async function() {
		await init();

		document.addEventListener('change', onFiltersChanged);
	});

	const init = async function () {
		const {type} = state.get();

		let dependencies = [];
		switch(type) {
			case 'model': dependencies = ['brand']; break;
			case 'year': dependencies = ['brand', 'model']; break;
		}

		state.set(s => s.dependencies = dependencies);

		if (!dependencies.length) await setOptions();
	}

	const onFiltersChanged = async function(e) {
		const filter = e.target.closest('[data-set]');
		if (!filter) return;

		const {dependencies} = state.get();
		const changedType = filter.dataset.set;

		if (dependencies.includes(changedType)) {
			selectChoices.choices.clearChoices(true, true);
		}

		const filters = getFilters();
		if (filters !== false) {
			selectChoices.choices.enable();
			await setOptions(filters);
		} else {
			selectChoices.choices.clearChoices(true, true);
			selectChoices.choices.disable();
		}
	};

	const setOptions = async function (filters = []) {
		const {type} = state.get();

		const query = new URLSearchParams({
			route: elm.dataset.source,
			filters: filters.join(','),
			type
		});

		try {
			const response = await fetch(`index.php?${query}`);
			const results = await response.json();

			selectChoices.choices.clearChoices();
			selectChoices.choices.setChoices(results, 'value', 'label', true, true);
		} catch (error) {
			console.error('Error fetching dynamic search results:', error);
		}
	};

	const getFilters = function () {
		const {dependencies} = state.get();
		const values = [];

		for (const dependency of dependencies) {
			const option = document.querySelector(`[data-set='${dependency}'] option:checked`);
			if (!option) return false;

			const properties = JSON.parse(option.dataset.customProperties)
			values.push(properties.id);
		}

		return values;
	}
};

export const model = {
	dependencies: []
};
